import React from 'react'
import '../assets/styles/Accueil.css'
import Header from '../components/Header'
import ListFilm from '../components/ListFilm'

function Accueil() {
  return (
    <div >
    <div id="test" className="AccueilContainer">
        <Header />
        <ListFilm />
    </div>
      <div className="buttonRetourAccueil">
        <a href='#test'><button id="buttonRetourAccueil">RETOUR</button></a>
      </div>
    </div>
  )
}

export default Accueil